<template>
    <div class="stats-admin" v-if="currentUser">
        <div class="page-header">
            <h1>Statystyki Panelu</h1>
        </div>

        <div class="stats-layout">
            <div class="stats-section">
                <div class="section-card">
                    <div class="section-card-header">
                        <h2>Kliknięcia w wizytówki partnerów</h2>
                    </div>

                    <div class="stats-list">
                        <div class="stat-card" v-for="stat in partnerStats" :key="stat.id">
                            <div class="stat-card-body">
                                <div class="stat-info">
                                    <h3 class="partner-name">{{ stat.name }}</h3>
                                    <p class="partner-url">{{ stat.url }}</p>
                                </div>
                                <div class="stat-value">
                                    <span class="click-count">{{ stat.clicks }}</span>
                                    <span class="click-label">kliknięć</span>
                                </div>
                            </div>
                        </div>

                        <div v-if="partnerStats.length === 0" class="empty-state">
                            <p>Brak danych o statystykach.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';

export default {
    name: 'StatsView',
    setup() {
        return {
            authStore: useAuthStore(),
        };
    },
    data() {
        return {
            partnerStats: [],
        };
    },
    computed: {
        currentUser() {
            return this.authStore.user;
        },
    },
    mounted() {
        if (!this.currentUser || this.currentUser.role_id !== 1) {
            this.$router.push('/login');
            return;
        }
        this.getPartnerStats();
    },
    methods: {
        getPartnerStats() {
            // Kontrakt: GET /PartnerStats
            axios.get('/PartnerStats', authHeader())
                .then(res => {
                    this.partnerStats = res.data;
                })
                .catch(err => {
                    console.error('Błąd podczas pobierania statystyk:', err);
                });
        },
    },
};
</script>

<style scoped>
.stats-admin {
    max-width: 1200px;
    margin: 0 auto;
    padding: 32px 16px;
    font-family: sans-serif;
    box-sizing: border-box;
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 32px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
    font-size: 2.8rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
}

.stats-layout {
    display: flex;
    gap: 24px;
    align-items: flex-start;
}

.stats-section {
    flex: 1 1 0;
    min-width: 0;
}

.section-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 6px rgba(0,0,0,0.08);
    padding: 24px;
    box-sizing: border-box;
    width: 100%;
}

.section-card h2 {
    font-size: 2rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 16px 0;
}

.stats-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.stat-card {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 16px;
    transition: box-shadow 0.2s, border-color 0.2s;
}

.stat-card:hover {
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
    border-color: #10b981;
}

.stat-card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.partner-name {
    font-size: 1.7rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
}

.partner-url {
    font-size: 1.3rem;
    color: #6b7280;
    margin: 4px 0 0 0;
}

.stat-value {
    text-align: right;
    display: flex;
    flex-direction: column;
}

.click-count {
    font-size: 2.4rem;
    font-weight: 700;
    color: #10b981;
}

.click-label {
    font-size: 1.2rem;
    color: #9ca3af;
    text-transform: uppercase;
    font-weight: 600;
}

.empty-state {
    text-align: center;
    padding: 32px;
    color: #9ca3af;
    font-size: 1.5rem;
}

@media (max-width: 600px) {
    .stat-card-body {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    .stat-value {
        text-align: left;
    }
}
</style>
